import React, {Component} from 'react';
import {connect} from 'react-redux';
import FilterInput from './molecules/filter-input';
import FilterSlider from './molecules/filter-slider';
import Action from 'actions';

class SelectSalaryCap extends Component {
    componentDidMount() {
        this.setOuterSalaryCapIfNeeded();
    }

    componentDidUpdate() {
        this.setOuterSalaryCapIfNeeded();
    }

    shouldOuterSalaryCapBeSet() {
        const {sportConfig, salaryCap} = this.props;

        return sportConfig.hasRestrictions() && salaryCap.isOuterBoundariesDefault();
    }

    setOuterSalaryCapIfNeeded() {
        if (this.shouldOuterSalaryCapBeSet()) {
            this.props.dispatch(Action.set('OuterSalaryCapFromSportConfig'));
        }
    }

    canBeRendered() {
        const {salaryCap} = this.props;

        return !salaryCap.isOuterBoundariesDefault();
    }

    getFilterView() {
        if (!this.canBeRendered()) {
            return null;
        }

        const {step = 100, roundValue = 100, useDragging} = this.props;

        return (
            <div className="range-holder">
                <div className="slider-wrap">
                    <FilterSlider step={step} useDragging={useDragging} />
                </div>
                <div className="range-wrap">
                    <FilterInput fieldName="min" roundValue={roundValue} testId="min-salary-cap-input" />
                    <FilterInput fieldName="max" roundValue={roundValue} testId="max-salary-cap-input" />
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="filters-cell lineups-cell">
                <div className="filter-group">
                    <strong className="filter-title">Salary Cap</strong>
                    {/*
                        https://abnk.atlassian.net/browse/DFSA-229
                        The react sliders calculate the width of themselves in pixeles to set the shift of circles.
                        It is important not to return null at the beginning of the render methods
                        to occupy the necessary width before this calculation.
                    */}
                    {this.getFilterView()}
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {sportConfig, salaryCap} = state;

    return {
        sportConfig,
        salaryCap,
    };
}

export default connect(mapStatesToProps)(SelectSalaryCap);
